import {createSelector} from '@ngrx/store';
import {identity} from 'rxjs';
import {AppState} from '../states/app.state';
import {FakturierungsbelegEntitiesSelectors} from './fakturierungsbeleg-entities.selectors';


export class FakturierungsbelegTableSelectors {

  private static select = {
    tableSettings: (state: AppState) => state.fakturierungsbelegTable.tableSettings,
    displayedIds: (state: AppState) => state.fakturierungsbelegTable.displayedIds,
    pageableDto: (state: AppState) => state.fakturierungsbelegTable.pageableDto,
    totalPages: (state: AppState) => state.fakturierungsbelegTable.totalPages,
    isLoaded: (state: AppState) => state.fakturierungsbelegTable.isLoaded,
  };

  public static tableSettings = createSelector(
    this.select.tableSettings,
    identity,
  );

  public static displayedFakturierungsbelege = createSelector(
    this.select.displayedIds,
    FakturierungsbelegEntitiesSelectors.all,
    (selectedIds, belege) =>
      FakturierungsbelegEntitiesSelectors.belegeByIds(selectedIds).projector(belege)
  );

  public static pageableDto = createSelector(
    this.select.pageableDto,
    identity,
  );

  public static totalPages = createSelector(
    this.select.totalPages,
    identity,
  );

  public static fakturierungsbelegeLoaded = createSelector(
    this.select.isLoaded,
    identity,
  );

}
